var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"main-footer"}},[_c('p',[_vm._v(" Copyright 2021@ Magdalena Bygg och Måleri.se")])])}]

export { render, staticRenderFns }